import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationTasksSectionToggled.meta';

export type UseTrackAutomationTasksSectionToggledParams = {
  is_expanded: boolean;
  automation_count: number;
};

export const useTrackAutomationTasksSectionToggled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationTasksSectionToggled = useCallback(
    (params: UseTrackAutomationTasksSectionToggledParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationTasksSectionToggled };
};
